

































import { ApiClient } from "@/api/client";
import { Component, Vue } from "vue-property-decorator";
import { UserAccount } from "@/interfaces/user";
import { mapState } from "vuex";
import store from "@/store";

@Component({
  computed: {
    ...mapState(["user"])
  }
})
export default class SofortIdentCallback extends Vue {
  // Mapped from Vuex
  user!: UserAccount;

  interval: any;

  mounted() {
    const client = new ApiClient();
    if (this.$route.query.agecheck_result === "valid") {
      if (!this.user.age_verified) {
        this.interval = setInterval(() => {
          client.getAccountInfo().then(user => {
            store.commit("setUser", user);
            if (user.age_verified) {
              clearInterval(this.interval);
              this.$router.push("feed");
            }
          });
        }, 2000);
      } else {
        this.$router.push("feed");
      }
    } else if (this.$route.query.agecheck_result === "user_abort") {
      this.$router.push("verify_age");
    }
  }
}
